import { ContainerWatch } from './containerWatch'
import { ImportStatus } from './importStatus'
import type { GETAppointmentWithContainer } from '~/services/apiClient'
import { Appointment } from '~/models/appointments'
import { AppointmentStatus, ContainerWatchState } from '~/services/apiClient'

export class AppointmentWithContainerInfo {
  appointment: Appointment
  container_number: string
  import_status: ImportStatus | undefined
  watch: ContainerWatch

  constructor(appointment: GETAppointmentWithContainer, demoMode: boolean) {
    this.appointment = new Appointment(appointment.appointment, demoMode)
    // with_container_info appointments are joined to a container watch, so
    // container_number is always present here despite the API type now allowing
    // null for containerless appointments (export empty pickups; see DEV-7283).
    this.container_number = appointment.appointment.container_number ?? ''
    this.watch = new ContainerWatch(appointment.watch, demoMode)
    this.import_status = appointment.import_status
      ? new ImportStatus(appointment.import_status)
      : undefined
  }

  get pickup_number() {
    return this.watch.import_appointment_pickup_number
  }

  get moveTypeDescription(): string {
    const isPickup = this.appointment.direction === 'outbound'
    const verb = isPickup ? 'Pick-up' : 'Drop-off'
    const containerType = this.appointment.loaded ? 'load' : 'empty'
    return `${verb} ${containerType}`
  }

  /**
   * Check if this is an LBCT exempt appointment (container numbers ending in "1")
   * @returns true if this is an exempt appointment at LBCT, false otherwise
   */
  get is_exempt(): boolean {
    // LBCT exempt appointments: container numbers ending in "1"
    return (
      this.appointment.terminal === 'lbct' &&
      this.container_number.endsWith('1')
    )
  }

  get importStatusAwareAppointmentStatus(): AppointmentStatus {
    if (
      this.appointment.is_import_out &&
      this.watch.state === ContainerWatchState.ImportPickedUp
    ) {
      return AppointmentStatus.Completed
    }
    return this.appointment.status
  }
}
